import React, { useState } from "react";
import BulkReschedule from "../BulkReschedule";
import {
  BULK_RESCHEDULE,
  MY_VACATIONS,
  UPDATE_SCHEDULE,
  VIEW_CALENDAR,
} from "../Constants";
import VacationsDays from "../MyVacations/vacations";
import UpdateScheduleDetails from "../UpdateSchedule";
import ViewCalendarDetails from "../ViewCalendar";
import "./style.scss";
import "../ViewLogs/viewLog.scss";

export default function MyScheduleAndFeesTabComponent(props) {
  const {
    logType,
    staffDoctor,
    callProcedureApi,
    roleNameMenu,
    tableData,
    logFilterData,
    setLogType,
    handleViewLogOnFilter,
    handleViewLogOpened,
    setIsViewLogOpened,
    clinic_id,
    handleViewSlots,
    totalRecords,
    selectedRadioBtn,
    handleRadioBtn,
    isResourceArray,
    dropdownOptionsList
  } = props;
  const [showBackDrop, setShowBackDrop] = useState("");
  const displayViewDocumentsTabs = () => {
    return (
      <div className="prescription-tabs-cont">
        <div
          className={
            "prescription-tabs " +
            (logType === UPDATE_SCHEDULE ? "prescription-tab-selected" : "")
          }
          onClick={() => setLogType(UPDATE_SCHEDULE)}
        >
          <div className="tab-names">
            Update Schedule <br />
            <span style={{ fontSize: "12px" }}>
              Set duration and fee for consultation
            </span>
          </div>
        </div>
        <div
          className={
            "prescription-tabs " +
            (logType === VIEW_CALENDAR ? "prescription-tab-selected" : "")
          }
          onClick={() => setLogType(VIEW_CALENDAR)}
        >
          <div className="tab-names">
            View Calendar <br />
            <span style={{ fontSize: "12px" }}>
              Manage time slots for consultation{" "}
            </span>
          </div>
        </div>
        <div
          className={
            "prescription-tabs " +
            (logType === MY_VACATIONS ? "prescription-tab-selected" : "")
          }
          onClick={() => setLogType(MY_VACATIONS)}
        >
          <div className="tab-names">
            My Vacations <br />
            <span style={{ fontSize: "12px" }}>
              Plan your leaves / vacation
            </span>
          </div>
        </div>
        <div
          className={
            "prescription-tabs " +
            (logType === BULK_RESCHEDULE ? "prescription-tab-selected" : "")
          }
          onClick={() => setLogType(BULK_RESCHEDULE)}
        >
          <div className="tab-names">
            Bulk Reschedule <br />
            <span style={{ fontSize: "12px" }}>
              Bulk Reschedule Appointments
            </span>
          </div>
        </div>
      </div>
    );
  };

  const displayViewDocumentsTabContents = () => {
    return (
      <div className="prescription-tab-content">
        {logType === UPDATE_SCHEDULE && (
          <div>
            <UpdateScheduleDetails
              isResourceArray={isResourceArray}
              handleViewSlots={handleViewSlots}
              staffDoctor={staffDoctor}
              callProcedureApi={callProcedureApi}
              roleNameMenu={roleNameMenu["update_schedule"]}
              tableData={tableData}
              handleViewLogOnFilter={handleViewLogOnFilter}
              logFilterData={logFilterData}
              handleViewLogOpened={handleViewLogOpened}
              totalRecords={totalRecords}
              setShowBackDrop={setShowBackDrop}
              dropdownOptionsList={dropdownOptionsList["update_schedule"]}
            />
          </div>
        )}
        {logType === VIEW_CALENDAR && (
          <div>
            <ViewCalendarDetails
              isResourceArray={isResourceArray}
              staffDoctor={staffDoctor}
              callProcedureApi={callProcedureApi}
              roleNameMenu={roleNameMenu["view_calendar"]}
              tableData={tableData}
              handleViewLogOnFilter={handleViewLogOnFilter}
              logFilterData={logFilterData}
              handleViewLogOpened={handleViewLogOpened}
              setIsViewLogOpened={setIsViewLogOpened}
              totalRecords={totalRecords}
              setShowBackDrop={setShowBackDrop}
              dropdownOptionsList={dropdownOptionsList["view_calendar"]}
            />
          </div>
        )}
        {logType === MY_VACATIONS && (
          <div>
            <VacationsDays
              staffDoctor={staffDoctor}
              roleNameMenu={roleNameMenu["my_vacations"]}
              tableData={tableData}
              handleViewLogOnFilter={handleViewLogOnFilter}
              logFilterData={logFilterData}
              handleViewLogOpened={handleViewLogOpened}
              totalRecords={totalRecords}
              setShowBackDrop={setShowBackDrop}
              selectedRadioBtn={selectedRadioBtn}
              handleRadioBtn={handleRadioBtn}
            />
          </div>
        )}
        {logType === BULK_RESCHEDULE && (
          <div>
            <BulkReschedule
              staffDoctor={staffDoctor}
              clinic_id={clinic_id}
              roleNameMenu={roleNameMenu["bulk_reschedule"]}
              tableData={tableData}
              handleViewLogOnFilter={handleViewLogOnFilter}
              logFilterData={logFilterData}
              handleViewLogOpened={handleViewLogOpened}
              totalRecords={totalRecords}
              setShowBackDrop={setShowBackDrop}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div
        className={` ${showBackDrop === "btm-drawer" && "view-logs-disable-backdrop"
          }`}
      ></div>
      <div className="tab-component-prescription-cont">
        {displayViewDocumentsTabs()}
        {displayViewDocumentsTabContents()}
      </div>
    </>
  );
}
